import { render, staticRenderFns } from "./Config.vue?vue&type=template&id=4942bdd2&scoped=true&lang=pug&"
import script from "./Config.vue?vue&type=script&lang=ts&"
export * from "./Config.vue?vue&type=script&lang=ts&"
import style0 from "./Config.vue?vue&type=style&index=0&id=4942bdd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4942bdd2",
  null
  
)

export default component.exports